import { firestore, useUser } from "capsule"
import { useMemo } from "react"
import { useCollectionData } from "react-firebase-hooks/firestore"

import { collections } from "../../common/types"

interface ConfigType {
  passwordLifeTimeInDays: number
  autoLogoutDelayMinutes: number
}

export const useConfig = (): ConfigType | undefined => {
  const { userData } = useUser()
  const configCollection = useMemo(
    () => (userData ? firestore().collection(collections.CONFIG) : null),
    [userData],
  )
  const [configs] = useCollectionData<ConfigType>(configCollection)
  return configs?.[0]
}
